import CompanyRoutes, { COMPANY_BASE_ROUTES } from './CompanyRoutes';

export { CompanyRoutes, COMPANY_BASE_ROUTES };
